import React from "react";
import { Box } from "@chakra-ui/react";
import CmsPageTitle from "@/utils/CmsPageTitle";
import ContainerBox from "@/utils/ContainerBox";

const PrivacyPolicy = () => {
  return (
    <Box>
      <CmsPageTitle title="Privacy Policy" />
      <ContainerBox bgColor="bg-gray" Style=" gap-4 sm:gap-8">
        <Box className="container mx-auto">
          <Box className="py-4">
            <p className="mb-3">At SkilSoar, your privacy matters to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our platform. By using SkilSoar, you agree to the terms described here.</p>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">1. Information We Collect</h4>
              <p>We collect the following types of information:</p>
              <p>Account Information: Your name, email, phone number, city, state, and service preferences when signing up.</p>
              <p>Payment Details: Payments are processed securely through Stripe. SkilSoar does not store full credit card numbers.</p>
              <p>Mentor Verification: We collect professional data such as resumes, LinkedIn profiles, and employer details to verify mentors.</p>
              <p>Session Data: Booking details, messages, and session feedback may be collected for quality assurance and support.</p>
              <p>Usage Data: We collect technical information like IP address, browser type, and device info to improve performance and prevent fraud.</p>
            </Box>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">2. How We Use Your Information</h4>
              <p>We use your data to:</p>
              <p>Facilitate mentor/mentee connections and session scheduling.</p>
              <p>Process payments securely.</p>
              <p>Send notifications and updates.</p>
              <p>Improve our platform and services.</p>
              <p>Ensure safety and verify identity.</p>
              <p>Comply with legal obligations.</p>

            </Box>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">3. Sharing Your Information</h4>
              <p>We never sell your data.We may share information with:</p>
              <p>Stripe: To process secure payments</p>
              <p>Third - party providers: For email, hosting, and customer support(Sendgrid)</p>
              <p>Law enforcement: When legally required to do so</p>

            </Box>

            <Box className="mt-4">
              <h4 className="heading-color mb-2">4. Cookies & Tracking</h4>
              <p>We use cookies to personalize your experience and analyze site usage.You can control cookie settings through your browser.</p>
            </Box>

            <Box className="mt-4">
              <h4 className="heading-color mb-2">5. Data Security</h4>
              <p>We use industry - standard encryption and access controls to keep your data safe.Please use the platform responsibly.</p>
            </Box>

            <Box className="mt-4">
              <h4 className="heading-color mb-2">6. Your Rights</h4>
              <p>You have the right to:</p>
              <p>Access or update your information</p>
              <p>Delete your account</p>
              <p>Opt out of marketing communications.</p>
              <p>
                To exercise your rights, email us at {" "}
                <a href="mailto:support@skilsoar.com" className="text-blue-500 underline">
                  support@skilsoar.com
                </a>
              </p>
            </Box>

            <Box className="mt-4">
              <h4 className="heading-color mb-2">7. Children’s Privacy</h4>
              <p>SkilSoar is not intended for children under 18. We do not knowingly collect data from minors.</p>
            </Box>

            <Box className="mt-4">
              <h4 className="heading-color mb-2">8. Changes to This Policy</h4>
              <p>We may update this policy as our services evolve.We'll notify you of material changes via email or website notice.</p>
              <p>Skill Sour charges a service fee for facilitating the connection between Instructors and Participants. The fee will be deducted from the payment made by the Participant.</p>
              <p>All payments are processed securely through third-party payment processors.</p>
            </Box>

            <Box className="mt-4">
              <h4 className="heading-color mb-2">Have questions or concerns ?</h4>
              <p>
                Email:{" "}
                <a href="mailto:support@skilsoar.com" className="text-blue-500 underline">
                  support@skilsoar.com
                </a>
              </p>
            </Box>
          </Box>
        </Box>
      </ContainerBox>
    </Box>
  );
};

export default PrivacyPolicy;